import { Site } from '@superbet-group/web.types';
import { currentSite } from './domainHelpers';

let isBetlerPolandByCms = false;
export function isBetlerPoland(): boolean {
    return currentSite === Site.SuperbetBetlerPl || isBetlerPolandByCms;
}

export function setIsBetlerPoland(value: boolean): void {
    isBetlerPolandByCms = value;
}
